














import Proxyable from '@/mixins/proxyable';
import { IPaymentRequisition, IUser } from '@/models';
import { PropType } from 'vue';
import { mapActions, mapGetters } from 'vuex';

export default Proxyable.extend({
  name: 'PaymentRequisitionApproverPicker',

  props: {
    paymentRequisition: {
      type: Object as PropType<IPaymentRequisition>,
      required: true
    },
    externalErrorMessage: {
      type: String,
      default: () => ''
    },
    approvers: {
      type: Array as PropType<IUser[]>,
      default: () => []
    }
  },

  data: () => ({
    loading: false,
    errorMessage: ''
  }),

  computed: {
    ...mapGetters({
      fetchedApprovers: 'paymentRequisition/getPaymentRequisitionApprovers'
    }),

    approverList(): IUser[] {
      return this.approvers.length ? this.approvers : this.fetchedApprovers;
    },

    errorMessageList(): string[] {
      const errorList = [];
      if (this.externalErrorMessage) {
        errorList.push(this.externalErrorMessage);
      }
      if (this.errorMessage) {
        errorList.push(this.errorMessage);
      }

      return errorList;
    }
  },

  mounted() {
    this.init();
  },

  beforeDestroy() {
    this.errorMessage = '';
  },

  methods: {
    ...mapActions({
      fetchPaymentRequisitionApprovers:
        'paymentRequisition/fetchPaymentRequisitionApprovers'
    }),

    init() {
      if (!this.approvers.length) {
        this.loading = true;
        this.fetchPaymentRequisitionApprovers(this.paymentRequisition.id)
          .catch(() => {
            this.errorMessage = 'Error getting approvers';
          })
          .finally(() => (this.loading = false));
      }
    }
  }
});
